
  export default {
    setHide(state, hide) {
        state.hide = hide
        // 把登陆状态保存到localStorage中，防止页面刷新，导致vuex重新启动，状态就成为初始值（初始值为空）的情况
        localStorage.setItem('hide', hide)
      }
  }